import script from "./PasswordPoliciesList.vue?vue&type=script&setup=true&lang=ts"
export * from "./PasswordPoliciesList.vue?vue&type=script&setup=true&lang=ts"

import "./PasswordPoliciesList.vue?vue&type=style&index=0&id=4b9abb38&lang=css"

const __exports__ = script;

export default __exports__